import EstimatePage from "./Estimate";
import { PHONE, GOLD } from "../lib/constants";

const ESTIMATE_COPY_ES = {
  lang: "es",
  hero: {
    badge: "Cotización gratis",
    title: <>Arma tu <span style={{ color: GOLD }}>Cotización</span> Gratis</>,
    subtitle: "Responde 4 preguntas rápidas y recibe una cotización personalizada en menos de 24 horas — sin compromiso y sin cargos ocultos.",
  },
  steps: ["¿Qué necesitas limpiar?", "Cuéntanos sobre el espacio", "¿Con qué frecuencia y algún extra?", "¿A dónde enviamos tu cotización?"],
  stepOf: (n) => `Paso ${n} de 4`,
  groups: {
    size: "Tamaño aproximado",
    bedrooms: "Habitaciones (si aplica)",
    bathrooms: "Baños (si aplica)",
    frequency: "Frecuencia de limpieza",
    extras: "Extras (opcional — selecciona todos los que apliquen)",
  },
  placeholders: { name: "Nombre completo *", phone: "Número de teléfono *", email: "Correo electrónico *", notes: "¿Algo más que debamos saber? (opcional)" },
  buttons: { back: "Atrás", next: "Continuar", submit: "Obtener mi cotización", sending: "Enviando..." },
  success: {
    title: "¡Solicitud de cotización recibida!",
    body: (name) => <>¡Gracias, <strong>{name}</strong>! Nuestro equipo está preparando tu cotización personalizada — te contactaremos en menos de <strong>24 horas</strong>.</>,
    call: `¿Lo necesitas antes? Llama al ${PHONE}`,
  },
  error: `Algo salió mal. Inténtalo de nuevo o llámanos al ${PHONE}.`,
  options: {
    "Residential Home": "Casa residencial",
    "Airbnb / Vacation Rental": "Airbnb / Alquiler vacacional",
    "Restaurant": "Restaurante",
    "Office / Commercial": "Oficina / Comercial",
    "Other": "Otro",
    "Under 1,000 sq ft": "Menos de 1,000 pies²",
    "1,000–2,000 sq ft": "1,000–2,000 pies²",
    "2,000–3,000 sq ft": "2,000–3,000 pies²",
    "Over 3,000 sq ft": "Más de 3,000 pies²",
    "One-time": "Una sola vez",
    "Weekly": "Semanal",
    "Bi-weekly": "Cada dos semanas",
    "Monthly": "Mensual",
    "Deep cleaning": "Limpieza profunda",
    "Inside fridge & oven": "Interior de nevera y horno",
    "Interior windows": "Ventanas interiores",
    "Laundry & linens": "Lavandería y ropa de cama",
    "Move-in / Move-out": "Mudanza (entrada / salida)",
    "Post-construction": "Post-construcción",
  },
};

export default function EstimateEsPage() {
  return <EstimatePage copy={ESTIMATE_COPY_ES} />;
}
